<template>
  <section>
    <h3 class="text-xs font-semibold uppercase tracking-wide text-dashboard-muted mb-2 flex items-center gap-1.5">
      <component v-if="icon" :is="icon" class="w-3.5 h-3.5" />
      {{ title }}
    </h3>
    <div class="bg-dashboard-bg rounded-lg p-3 space-y-1.5 text-sm">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{ title: string; icon?: any }>()
</script>
